import React, { useState, useEffect } from "react";
import { feesHeadings } from "../../Constant/grades";
import { users as userData } from '../../Constant/usersChild';
import FeesTable from "../../Components/parent/FeesTable";
import { useTranslation } from "react-i18next";
import { useChild } from "../../ContextAPI/ChildContext";
import { getRequest } from "../../services";

const Fees = () => {
  const [processedData, setProcessedData] = useState({});
  const [paidFees, setPaidFees] = useState();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language;
  const { selectedChildId } = useChild();
  const activeUser = userData.find(user => user.isActive === true);
  const table = activeUser?.fees;

  const newData = table?.map((item, index) => ({
    ...item,
    avatar: userData[index]?.avatar
  }));

  useEffect(() => {
    const fetchStudentFeeBill = async () => {
      try {
        const response = await getRequest(`/api/FeeManagement/GetStudentFeeBill?studentId=${selectedChildId}`);
        const data = response.data.feeDetails;
        const formatData = {
          Discounts: data.appliedDiscounts.map(discount => ({
            discountName: discount.discountName,
            discountAmount: discount.discountAmount
          })),
          TutionFee: data.tutionFee,
          LabFee: data.labFee,
          EquipmentFee: data.equipmentFee,
          LibraryFee: data.libraryFee,
          SportsFee: data.sportsFee,
          LMSFee: data.lmsFee,
          AdmissionFee: data.admissionFee,
          SecurityFee: data.securityFee,
          MealFee: data.mealFee,
          TaxesFee: data.taxesFee,
          SchoolFines: data.schoolFines,
          LatePaymentFine: data.latePaymentFine,
          TotalFee: data.totalFee,
          TotalDiscountAmount: data.totalDiscountAmount,
          FinalAmount: data.finalAmount
        }
        setProcessedData(formatData);
      } catch (error) {
        console.error("Error fetching student fee bill:", error);
      }
    };

    const fetchPaidFees = async () => {
      try {
        const response = await getRequest(`/api/FeeManagement/GetPayments/${selectedChildId}`);
        const data = response.data;
        setPaidFees(data);
      } catch (error) {
        console.error("Error fetching paid fees:", error);
      }
    };
    if (selectedChildId) {
      fetchStudentFeeBill();
      fetchPaidFees();
    }
  }, [selectedChildId]);

  const calculateTotal = (fees) => {
    return Object.values(fees).reduce((acc, fee) => acc + (fee || 0), 0);
  };

  return (
    <>
      <div className="container-fluid shadow px-4 mt-4 py-3 bg-white rounded">
        <h2 className="heading24px fw-bold text-center">{t("FeesDetails")}</h2>
        <div className="Salary_card">
          <div className="Salary_Report">
          </div>
          <div className="Table_Card">
            <table>
              <tbody>
                <tr>
                  <th colSpan="2" className="Salary_Data text-primary">{t("TutionFee")}</th>
                  <td className="Salary_Data">{processedData.TutionFee} Rs</td>
                  <th colSpan="2" className="Salary_Data text-primary">{t("SportsFee")}</th>
                  <td className="Salary_Data">{processedData.SportsFee} Rs</td>
                </tr>
                <tr>
                  <th colSpan="2" className="Salary_Data text-primary">{t("LabFee")}</th>
                  <td className="Salary_Data">{processedData.LabFee} Rs</td>
                  <th colSpan="2" className="Salary_Data text-primary">{t("LMSFee")}</th>
                  <td className="Salary_Data">{processedData.LMSFee} Rs</td>
                </tr>
                <tr>
                  <th colSpan="2" className="Salary_Data text-primary">{t("EquipmentFee")}</th>
                  <td className="Salary_Data">{processedData.EquipmentFee} Rs</td>
                  <th colSpan="2" className="Salary_Data text-primary">{t("MealFee")}</th>
                  <td className="Salary_Data">{processedData.MealFee} Rs</td>
                </tr>
                <tr>
                  <th colSpan="2" className="Salary_Data text-primary">{t("LibraryFee")}</th>
                  <td className="Salary_Data">{processedData.LibraryFee} Rs</td>
                  <th colSpan="2" className="Salary_Data text-primary"></th>
                  <td className="Salary_Data"></td>
                </tr>
                <tr>
                  <th colSpan="2" className="Salary_Data text-primary fw-bold">{t("Total")}</th>
                  <td className="Salary_Data fw-bold">{calculateTotal({
                    tutionFee: processedData.TutionFee,
                    equipmentFee: processedData.EquipmentFee,
                    labFee: processedData.LabFee,
                    libraryFee: processedData.LibraryFee
                  })} Rs</td>
                  <th colSpan="2" className="Salary_Data text-primary fw-bold">{t("Total")}</th>
                  <td className="Salary_Data fw-bold">{calculateTotal({
                    sportsFee: processedData.SportsFee,
                    lmsFee: processedData.LMSFee,
                    mealFee: processedData.MealFee
                  })} Rs</td>
                </tr>
                <tr>
                  <th colSpan="6" className="Salary_Data text-primary">-</th>
                </tr>
                <tr>
                  <td colSpan="4" className="Salary_Data text-primary">{t("AdmissionFee")}</td>
                  <td colSpan="2" className="Salary_Data">{processedData.AdmissionFee} Rs</td>
                </tr>
                <tr>
                  <td colSpan="4" className="Salary_Data text-primary">{t("SecurityFee")}</td>
                  <td colSpan="2" className="Salary_Data">{processedData.SecurityFee} Rs</td>
                </tr>
                <tr>
                  <td colSpan="4" className="Salary_Data text-primary">{t("TaxesFee")}</td>
                  <td colSpan="2" className="Salary_Data">{processedData.TaxesFee} Rs</td>
                </tr>
                <tr>
                  <td colSpan="4" className="Salary_Data text-danger">{t("LatePaymentFine")}</td>
                  <td colSpan="2" className="Salary_Data text-danger">{processedData.LatePaymentFine} Rs</td>
                </tr>
                <tr>
                  <td colSpan="4" className="Salary_Data text-success">{t("TotalDiscount")}</td>
                  <td colSpan="2" className="Salary_Data text-success">-{processedData.TotalDiscountAmount} Rs</td>
                </tr>
                <tr>
                  <td colSpan="4" className="Salary_Data text-primary fw-bold">{t("FinalAmount")}</td>
                  <td colSpan="2" className="Salary_Data fw-bold">{processedData.FinalAmount} Rs</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="container-fluid shadow px-4 mt-4 py-3 bg-white rounded">
        <div className="row">
          <div className="col-md-12">
            <h4 className="text-center fw-bold py-4">List of Student Fees</h4>
          </div>
        </div>
        <div className="row mt-3">
          <FeesTable headings={feesHeadings} data={paidFees} />
        </div>
      </div>
    </>
  );
};

export default Fees;
